/* eslint-disable react/prop-types */
import './index.scss';
import ModalBase from '.';
import { ModalProps } from '../../types';
import { useEffect, useState } from 'react';
import { Button, Input, Select } from '@piggytechng/component-library';
import { OverideButtonStyle, OverideInputStyle, OverideSelectStyle } from '../../helpers/utils';
import useCustomers from '../../hooks/useCustomers';

function ModalChangeWithdrawalBank({ modalIsOpen, setIsOpen, isLoading, action }: ModalProps) {
  const SelectStyle = { ...OverideSelectStyle, style: { ...OverideSelectStyle.style, zIndex: undefined } };

  const { bankList, verifyBankNumber } = useCustomers();

  function closeModal() {
    if (isLoading) return;
    setIsOpen(false);
  }

  const [form, setForm] = useState({
    number: '',
    name: '',
    email: '',
    bank: '',
  });

  const [isLoadingAccountName, setIsLoadingAccountName] = useState(false);

  const Banks = (bankList ?? []).map((bank: any) => ({ label: bank.bm_name, value: bank.bm_code }));

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    action && action();
  };

  useEffect(() => {
    setForm({
      name: '',
      number: '',
      email: '',
      bank: '',
    });
  }, [modalIsOpen]);

  useEffect(() => {
    const verifyBank = async () => {
      if (form.bank && form.number.length < 10 && form.number.length > 8) {
        setIsLoadingAccountName(true);
        setForm({ ...form, name: 'Loading...' });
      } else if (form.bank && form.number.length === 10) {
        const response = await verifyBankNumber(form.bank, form.number);
        setForm({ ...form, name: response });
        setIsLoadingAccountName(false);
      } else {
        setForm({ ...form, name: '' });
        setIsLoadingAccountName(false);
      }
    };
    verifyBank();
  }, [form.number]);

  return (
    <ModalBase modalIsOpen={modalIsOpen} setIsOpen={setIsOpen}>
      <div className={`modal-processor`}>
        <div className="modal-processor__header">
          <h2>Withdrawal Bank</h2>
          <button onClick={closeModal}>&times;</button>
        </div>

        <form className="modal-processor__body" onSubmit={handleSubmit}>
          <Select
            {...SelectStyle}
            labelStyle={{ color: '#666766' }}
            options={Banks}
            backgroundColor="#F9FAFB"
            outlineColor="none"
            label="Bank"
            placeholder="Select Bank"
            value={isLoadingAccountName ? 'Loading...' : form.bank}
            onChange={(e) => setForm({ ...form, bank: e })}
          />

          <Input
            {...OverideInputStyle}
            labelStyle={{
              color: '#666766',
            }}
            label="Account Number"
            value={form.number}
            onChange={(e) => setForm({ ...form, number: e.target.value })}
          />

          <Input
            {...OverideInputStyle}
            labelStyle={{
              color: '#666766',
            }}
            disabled
            label="Account name"
            value={form.name}
          />

          <div className="modal-processor__actions">
            <Button
              {...OverideButtonStyle}
              className="modal-processor__actions-resolve"
              type="submit"
              loading={isLoading}
            >
              Update
            </Button>
          </div>
        </form>
      </div>
    </ModalBase>
  );
}

export default ModalChangeWithdrawalBank;
